// #1923: ververst een Turbo Frame om de paar seconden zolang de inhoud zegt
// dat er nog iets bezig is (data-bezig="true" in het frame). Gebruikt voor het
// verzendresultaat van facturen.
import { Controller } from "stimulus"

export default class extends Controller {
  static values = { interval: { type: Number, default: 3000 } }

  connect() {
    this.plan = this.plan.bind(this)
    this.element.addEventListener("turbo:frame-load", this.plan)
    this.plan()
  }

  disconnect() {
    clearTimeout(this.timer)
    this.element.removeEventListener("turbo:frame-load", this.plan)
  }

  plan() {
    clearTimeout(this.timer)
    if (!this.element.querySelector("[data-bezig='true']")) return

    this.timer = setTimeout(() => {
      if (typeof this.element.reload === "function") this.element.reload()
      else window.location.reload()
    }, this.intervalValue)
  }
}
